/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * This property has many enum values as below which is used to get the respective property of the battery.
 */
export var batteryProperty;
(function (batteryProperty) {
    batteryProperty["USAGE"] = "usage";
    batteryProperty["CHARGE_EFFICIENCY"] = "chargeEfficiency";
    batteryProperty["CHARGE_LEVEL_AT_KEY_OFF"] = "chargeLevelAtKeyOff";
    batteryProperty["SUBSCRIPTION_UTILIZATION"] = "subscriptionUtilization";
    batteryProperty["ALERTS"] = "alerts";
    batteryProperty["CHARGE_CYCLE"] = "chargeCycle";
    batteryProperty["CHARGE_TRANSACTION_DETAILS"] = "chargeTransactionDetails";
    batteryProperty["CHARGE_TRANSACTION_SUMMARY"] = "chargeTransactionSummary";
})(batteryProperty || (batteryProperty = {}));
